import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import pageStyles from "./styles";

interface DialogFormComponentProps {
  show: boolean;
  title: string;
  text: string;
  leftBtText?: string;
  rightBtText?: string;
  funcLeft?: any;
  funcRight?: any;
  inputs: any[];
  vc: object;
  changeVc: any;
  subtext?: string;
  subtextLink?: string;
  textLink?: string;
}

const DialogFormComponent = ({
  show,
  title,
  text,
  subtext = "",
  leftBtText,
  rightBtText,
  funcLeft,
  funcRight,
  inputs,
  vc,
  changeVc,
  subtextLink,
  textLink,
}: DialogFormComponentProps) => {
  const styles = pageStyles();

  const onChangeText = (event) => {
    if (event.persist) {
      event.persist();
    }
    if (event.target) {
      changeVc({ [event.target.name]: event.target.value });
    }
  };

  const renderLinkDescription = () => {
    const startIndex = text.indexOf("[[");
    const endIndex = text.indexOf("]]");
    const linkText = text.slice(startIndex + 2, endIndex);
    const leftText = text.slice(0, startIndex);
    const rightText = text.slice(endIndex + 2);

    if (startIndex > -1) {
      return (
        <span>
          {leftText}
          <a href={textLink} target="blank">
            {linkText}
          </a>
          {rightText}
        </span>
      );
    }

    return text;
  };

  const renderLink = () => {
    const startIndex = subtext.indexOf("[[");
    const endIndex = subtext.indexOf("]]");
    const linkText = subtext.slice(startIndex + 2, endIndex);
    const leftText = subtext.slice(0, startIndex);
    const rightText = subtext.slice(endIndex + 2);

    if (startIndex > -1) {
      return (
        <span>
          {leftText}
          <a href={subtextLink} target="blank">
            {linkText}
          </a>
          {rightText}
        </span>
      );
    }

    return subtext;
  };

  return (
    <Dialog
      open={show}
      aria-labelledby="form-dialog-title"
      classes={{ paper: styles.container }}
    >
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{renderLinkDescription()}</DialogContentText>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            marginTop: 6,
          }}
        >
          {inputs.map(
            (item, index) =>
              item && (
                <TextField
                  key={"input-modal-" + index}
                  margin="dense"
                  label={item.label}
                  value={vc[item.value]}
                  className={inputs.length > 1 ? styles.inputs : styles.input}
                  name={item.value}
                  onChange={onChangeText}
                  type={item.type || "text"}
                  autoComplete="off"
                  placeholder={item.placeholder || ""}
                  disabled={item.disabled}
                  autoFocus={index === 0}
                  variant="standard"
                />
              )
          )}
        </div>
        <DialogContentText style={{ fontSize: 12, marginTop: 12 }}>
          {renderLink()}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {leftBtText && (
          <Button
            onClick={funcLeft}
            color="primary"
            className={styles.buttonCancel}
          >
            {leftBtText}
          </Button>
        )}
        <Button
          onClick={funcRight}
          color="primary"
          className={styles.buttonDone}
        >
          {rightBtText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogFormComponent;
